import { render } from "./CustomerSummaryReportView.vue?vue&type=template&id=0b89e695&scoped=true"
import script from "./CustomerSummaryReportView.vue?vue&type=script&lang=js"
export * from "./CustomerSummaryReportView.vue?vue&type=script&lang=js"

import "./CustomerSummaryReportView.vue?vue&type=style&index=0&id=0b89e695&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b89e695"]])

export default __exports__